import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import 'url-search-params-polyfill';

ReactDOM.render(<App />, document.getElementById('root'));